import { h } from 'preact'; /** @jsx h */
import { useEffect, useRef, useState } from 'preact/hooks';
import { getPerson, login } from '../../../forms/apiFunctions';

import InputField from '../InputField/InputField';

import './Login.scss';

const Login = ({
    isTablet,
    setTabletView,
    setUser,
    setIsRegistered,
    registrationDetails,
    setRegistrationDetails
}) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [loginCode, setLoginCode] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState();
    const [loginError, setLoginError] = useState();
    const [lookupMsg, setLookupMsg] = useState(
        'Vi fant ikke informasjon om deg. Vennligst fyll ut skjemaet under for å fortsette.'
    );
    const [errors, setErrors] = useState({});

    const [step, setStep] = useState(1);

    useEffect(() => {
        // check urlpath for params containing error messages and set them to state if they exist
        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error');

        if (error) {
            setPhoneNumberError(`${error}, vennligst prøv igjen`);
        }
    }, []);

    const handleRegistrationRequest = () => {
        const noSpacePhoneNumber = phoneNumber.replace(/\s/g, '');

        const validPhone = /^\+?\d{8,12}$/.test(noSpacePhoneNumber);

        if (validPhone) {
            getPerson({ mobilnr: noSpacePhoneNumber }).then(response => {
                if (Object.keys(response).length > 1 && response.fornavn) {
                    const newRegistrationDetails = {
                        ho_fnavn: response.fornavn,
                        ho_enavn: response.etternavn,
                        ho_epost: response.epost,
                        adresse1: response.adresse,
                        postnr: response.postnr,
                        poststed: response.poststed,
                        ho_mobilnr: noSpacePhoneNumber
                    };
                    setRegistrationDetails(newRegistrationDetails);
                    setPhoneNumberError(null);
                    setStep(3);
                    setLookupMsg(
                        'Vi fant noe informasjon om deg. Vennligst rediger skjemaet under for å fortsette.'
                    );
                } else {
                    setLookupMsg(
                        'Vi fant ikke informasjon om deg. Vennligst fyll ut skjemaet under for å fortsette.'
                    );
                    setRegistrationDetails({ ho_mobilnr: noSpacePhoneNumber });
                    setPhoneNumberError(null);
                    setStep(3);
                }
            });
        }
        setStep(3);
    };

    const handleRegistration = () => {
        // Check if required fields are filled out
        const newErrors = {};

        if (!registrationDetails?.ho_fnavn) {
            newErrors.ho_fnavn = 'Fornavn er påkrevd';
        }

        if (!registrationDetails?.ho_enavn) {
            newErrors.ho_enavn = 'Etternavn er påkrevd';
        }

        if (!registrationDetails?.adresse1) {
            newErrors.adresse1 = 'Adresse er påkrevd';
        }

        if (!registrationDetails?.postnr) {
            newErrors.postnr = 'Postnummer er påkrevd';
        }

        if (!registrationDetails?.poststed) {
            newErrors.poststed = 'Poststed er påkrevd';
        }

        if (!registrationDetails?.ho_mobilnr) {
            newErrors.ho_mobilnr = 'Mobilnummer er påkrevd';
        }

        if (!registrationDetails?.ho_epost) {
            newErrors.ho_epost = 'E-post er påkrevd';
        }

        // Email validation
        const emailRegex = /\S+@\S+\.\S+/;
        if (registrationDetails?.ho_epost && !emailRegex.test(registrationDetails?.ho_epost)) {
            newErrors.ho_epost = 'E-post er ikke gyldig';
        }

        // If there are errors, set them and stop here
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            return;
        }

        if (registrationDetails && registrationDetails.ho_fnavn) {
            setRegistrationDetails({ ...registrationDetails, ho_mobilnr: phoneNumber });
            setIsRegistered(true);
            setUser(registrationDetails);
            setStep(1);
        } else {
            setIsRegistered(false);
            setUser(null);
            setLoginError('Noe gikk galt. Vennligst prøv igjen.');
            setStep(1);
        }

        localStorage.setItem('snla-user', JSON.stringify(registrationDetails));
    };

    const checkPhoneNumber = targetPhoneNumber => {
        // Check if targetPhoneNumber is empty
        if (!targetPhoneNumber) {
            setPhoneNumberError('Du må fylle inn et mobilnummer');
            return;
        }

        let inputPhoneNumber = '';
        if (phoneNumber === '') {
            setPhoneNumber(targetPhoneNumber);
            inputPhoneNumber = targetPhoneNumber;
        } else {
            inputPhoneNumber = phoneNumber;
        }

        return new Promise((resolve, reject) => {
            const noSpacePhoneNumber = inputPhoneNumber.replace(/\s/g, '');

            const validPhone = /^\+?\d{8,12}$/.test(noSpacePhoneNumber);

            if (validPhone) {
                // kall API for å få medlemsinfo
                login(noSpacePhoneNumber)
                    .then(() => {
                        setStep(2); // Go to login code step
                        setPhoneNumberError(null);
                        resolve(true);
                    })
                    .catch(e => {
                        // If the phone number is not in the database, go to registration
                        // if (e.message === 'Ingen støttemedlemsdata') {
                        getPerson({ mobilnr: noSpacePhoneNumber }).then(response => {
                            if (Object.keys(response).length > 1 && response.fornavn) {
                                const newRegistrationDetails = {
                                    ho_fnavn: response.fornavn,
                                    ho_enavn: response.etternavn,
                                    ho_epost: response.epost,
                                    adresse1: response.adresse,
                                    postnr: response.postnr,
                                    poststed: response.poststed,
                                    ho_mobilnr: inputPhoneNumber
                                };
                                setRegistrationDetails(newRegistrationDetails);
                                setPhoneNumberError(null);
                                setStep(3);
                                setLookupMsg(
                                    'Vi fant noe informasjon om deg. Vennligst rediger skjemaet under for å fortsette.'
                                );
                            } else {
                                setLookupMsg(
                                    'Vi fant ikke informasjon om deg. Vennligst fyll ut skjemaet under for å fortsette.'
                                );
                                setRegistrationDetails({ ho_mobilnr: inputPhoneNumber });
                                setPhoneNumberError(null);
                                setStep(3);
                            }
                        });
                        // } else {
                        //     setPhoneNumberError(e.message);
                        // }
                        reject(e);
                    });
            } else {
                setPhoneNumberError('Ugyldig mobilnummer');
            }
        });
    };

    const handleLogin = e => {
        e.preventDefault();

        // check if the code is put in and if its 4 digits
        if (!loginCode || loginCode.length !== 4) {
            setLoginError('Ugyldig kode');
            return;
        }

        e.target.form.submit();
    };

    // Focus on the input field when the step changes to 2
    const inputRef = useRef(null);
    useEffect(() => {
        if (step === 2 && inputRef.current) {
            inputRef.current.focus();
        }
    }, [step]);

    // Otherwise, render the login form
    return (
        <div className="ws-order-login">
            {/* UserPanel - Login (with conditionals for known users, lookups and manuel creation of new members) */}

            {step === 1 && (
                <div className="ws-order-login-step login-step-1">
                    <div className="login-step-header action">
                        <div className="header-content">
                            <span className="header-number">1</span>
                            <h6 className="header-title">Logg inn / Registrer deg</h6>
                        </div>
                        <div className="header-action">
                            <span className="stepper">1/2</span>
                        </div>
                    </div>
                    <div className="login-step-content login-input">
                        <div className="description">
                            <p>
                                Hvis du allerede støtter oss kan du taste inn ditt mobilnummer og
                                trykke på &quot;Logg inn&quot; knappen. Da vil du få tilsendt en
                                firesifret kode på SMS fra oss som du må bruke i neste steg.
                            </p>
                        </div>
                        <div className="input-row login-input">
                            <InputField
                                type="tel"
                                label={'Mobilnummer*'}
                                name="phoneNumber"
                                value={phoneNumber}
                                onChange={e => setPhoneNumber(e.target.value)}
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        checkPhoneNumber(e.target.value);
                                    }
                                }}
                                errorMessage={phoneNumberError}
                                autoFocus={step === 1}
                            />
                            <div className="ws-login-btn-container">
                                <button
                                    className="ws-login-btn"
                                    onClick={() => checkPhoneNumber(phoneNumber)}
                                >
                                    Logg inn
                                </button>
                            </div>
                        </div>
                        <div className="login-step-divider" />
                        <div className="ws-register-section">
                            <div className="description">
                                <p>
                                    Hvis du ikke er registrert hos oss fra før av kan du trykke på
                                    knappen til høyre for å registrere deg.
                                </p>
                            </div>
                            <div className="ws-login-btn-container">
                                <button
                                    className="ws-login-btn"
                                    onClick={handleRegistrationRequest}
                                >
                                    Registrer deg
                                </button>
                            </div>
                        </div>
                        {isTablet && (
                            <button className="ws-back-btn" onClick={() => setTabletView('cart')}>
                                <span className="material-symbols-outlined icon">chevron_left</span>
                                Tilbake til handlevognen
                            </button>
                        )}
                    </div>
                </div>
            )}

            {step === 2 && (
                <div className="ws-order-login-step login-step-2">
                    <div className="login-step-header action">
                        <div className="header-content">
                            <span className="header-number">2</span>
                            <h6 className="header-title">Logg inn</h6>
                        </div>
                        <div className="header-action">
                            <span className="stepper">2/2</span>
                        </div>
                    </div>
                    <div className="login-step-content login-input">
                        <div className="description">
                            <p>
                                Hvis du allerede støtter oss, vil du straks motta en firesifret kode
                                på SMS som du må taste inn her for å logge inn.
                            </p>
                        </div>
                        <div className="login-step-divider" />
                        <form method="post" action="/medl/login.php" id="login">
                            <div className="input-row">
                                <InputField
                                    ref={inputRef}
                                    type="text"
                                    label={'Kode på SMS*'}
                                    name="phoneNumber-code"
                                    value={loginCode}
                                    onChange={e => setLoginCode(e.target.value)}
                                    errorMessage={loginError}
                                    autoComplete="off"
                                />
                                <input type="hidden" name="phoneNumber" value={phoneNumber} />
                                <input type="hidden" name="action" value="pin" />
                                <input
                                    type="hidden"
                                    name="redirect"
                                    value="/nettbutikk/handlevogn/"
                                />

                                <div className="ws-login-btn-container">
                                    <button className="ws-login-btn" onClick={e => handleLogin(e)}>
                                        Logg inn
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div className="bottom-btns">
                            <button className="ws-back-btn" onClick={() => setStep(1)}>
                                <span className="material-symbols-outlined icon">chevron_left</span>
                                Tilbake
                            </button>
                            <div className="registration">
                                <span className="registration-question">Ikke mottatt kode? </span>
                                <button className="ws-back-btn" onClick={handleRegistrationRequest}>
                                    Registrer deg
                                    <span className="material-symbols-outlined icon">
                                        chevron_right
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {step === 3 && (
                <div className="ws-order-login-step login-step-3">
                    <div className="login-step-header action">
                        <div className="header-content">
                            <span className="header-number">2</span>
                            <h6 className="header-title">
                                {registrationDetails.ho_fnavn
                                    ? 'Rediger kontaktinformasjonen'
                                    : 'Kontaktinformasjon'}
                            </h6>
                        </div>
                        <div className="header-action">
                            <span className="stepper">2/2</span>
                        </div>
                    </div>
                    <div className="login-step-content login-input">
                        <div className="description">
                            <p>{lookupMsg}</p>
                        </div>
                        <div className="login-step-divider" />
                        <div className="input-row">
                            <InputField
                                type="text"
                                label={'Fornavn*'}
                                name="firstName"
                                value={registrationDetails.ho_fnavn}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        ho_fnavn: e.target.value
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.ho_fnavn}
                            />
                            <InputField
                                type="text"
                                label={'Etternavn*'}
                                name="lastName"
                                value={registrationDetails.ho_enavn}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        ho_enavn: e.target.value
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.ho_enavn}
                            />
                        </div>
                        <div className="input-row">
                            <InputField
                                type="text"
                                label={'Adresse*'}
                                name="address"
                                value={registrationDetails.adresse1}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        adresse1: e.target.value
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.adresse1}
                            />
                        </div>
                        <div className="input-row">
                            <InputField
                                type="text"
                                label={'Postnummer*'}
                                name="zipCode"
                                value={registrationDetails.postnr}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        postnr: e.target.value
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.postnr}
                            />
                            <InputField
                                type="text"
                                label={'Poststed*'}
                                name="city"
                                value={registrationDetails.poststed}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        poststed: e.target.value
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.poststed}
                            />
                        </div>
                        <div className="input-row">
                            <InputField
                                type="phone"
                                label={'Mobilnummer*'}
                                name="phoneNumber"
                                value={phoneNumber || registrationDetails.ho_mobilnr}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        ho_mobilnr: e.target.value
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.ho_mobilnr}
                            />
                            <InputField
                                type="email"
                                label={'E-post*'}
                                name="email"
                                value={registrationDetails.ho_epost}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        ho_epost: e.target.value
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.ho_epost}
                            />
                        </div>
                        <div className="input-row">
                            <InputField
                                type="checkbox"
                                label={
                                    'Ja, jeg vil holde meg oppdatert på arbeidet til Stiftelsen Norsk Luftambulanse.'
                                }
                                name="consent"
                                value={registrationDetails.ho_epost_samt}
                                onChange={e =>
                                    setRegistrationDetails({
                                        ...registrationDetails,
                                        ho_epost_samt: e.target.checked ? 'J' : 'N'
                                    })
                                }
                                onKeyPress={e => {
                                    if (e.key === 'Enter') {
                                        handleRegistration();
                                    }
                                }}
                                errorMessage={errors.ho_epost_samt}
                            />
                        </div>
                        <div className="ws-registration-btn-container">
                            <button className="ws-back-btn" onClick={() => setStep(1)}>
                                <span className="material-symbols-outlined icon">chevron_left</span>
                                Tilbake
                            </button>
                            <button
                                className="ws-register-btn"
                                onClick={() => handleRegistration()}
                            >
                                Registrer deg
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Login;
